import React from 'react';
import { FormField, FormItem, FormLabel, FormDescription, FormMessage, FormControl } from '@/shared/components/ui/form';
import { BaseFieldProps } from './types';
import { FacetSelector } from '@/features/Facets/components/FacetSelector';
import type { FacetFilter } from '@/features/Facets/types';

/**
 * Workflow node field type "facetselector" — usuário marca facetas no nó
 * knowledge_base_query (ou outros que aceitem facetas) (PBI 79319 — Camada 2).
 *
 * Persistência: o valor armazenado em form é Array<{name, value}> diretamente,
 * compatível com o que o backend espera em config.facets.
 */
export const FacetSelectorField: React.FC<BaseFieldProps> = ({ field, name, control }) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field: formField }) => {
        const value: FacetFilter[] = Array.isArray(formField.value) ? formField.value : [];
        return (
          <FormItem>
            <FormLabel>{field.label}</FormLabel>
            <FormControl>
              <FacetSelector
                value={value}
                onChange={(next) => formField.onChange(next)}
                className="w-full"
              />
            </FormControl>
            {field.description && <FormDescription>{field.description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export default FacetSelectorField;
